(function () {
  "use strict";

  /**
   * 1. ESTADO GLOBAL LEVE
   */
  window.Theme = {
    ready: false,
    modules: {}
  };

  /**
   * 2. UTILITÁRIO: LOAD SEGURO
   */
  function loadScript(src, opts = {}) {
    return new Promise((resolve, reject) => {
      const s = document.createElement("script");

      s.src = src;
      s.async = true;
      s.defer = true;

      if (opts.module) s.type = "module";

      s.onload = resolve;
      s.onerror = reject;

      document.head.appendChild(s);
    });
  }

  /**
   * 3. INIT ULTRA LEVE (RODA IMEDIATO)
   * Apenas o essencial para renderizar UI
   */
  function initCritical() {
    // NÃO colocar fetch, não chamar apps aqui
    document.documentElement.classList.add("theme-ready");
  }

  /**
   * 4. INIT LAZY (DEPOIS DO LOAD COMPLETO)
   * Aqui sim você libera tudo pesado
   */
  function initLazy() {
    requestIdleCallback(async () => {
      try {
        window.Theme.ready = true;

        // EXEMPLO: carregar módulos pesados só depois
        // (evita critical request chain)
        const modules = [];

        if (window.Shopify?.routes?.cart_url) {
          modules.push(loadScript("/assets/cart-module.js"));
        }

        if (document.querySelector("[data-quiz]")) {
          modules.push(loadScript("/assets/quiz.js"));
        }

        await Promise.all(modules);

      } catch (e) {
        console.warn("Lazy init error:", e);
      }
    });
  }

  /**
   * 5. EVITA CHAMADAS EM CADEIA NO LOAD
   */
  function disableEarlyFetches() {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const url = args?.[0];

      // bloqueia requests não críticos no início
      if (typeof url === "string") {
        if (
          url.includes("/collections/") ||
          url.includes("/cart") ||
          url.includes("/pages/")
        ) {
          if (!window.Theme.ready) {
            // adia request
            return new Promise((resolve) => {
              setTimeout(() => {
                resolve(originalFetch(...args));
              }, 1500);
            });
          }
        }
      }

      return originalFetch(...args);
    };
  }

  /**
   * 6. BOOT SEGURO
   */
  function boot() {
    initCritical();

    window.addEventListener("load", () => {
      initLazy();
    });

    disableEarlyFetches();
  }

  boot();
})();